<template>
  <Icon
    :class="[
      $style.collapseCaret,
      collapsed ? $style.collapsed : $style.notCollapsed
    ]"
    icon="chevronUp"
    :scale="0.75"
  />
</template>
<script>
import { Icon } from '@jumpcloud/ui-components';

export default {
  name: 'CollapseCaret',

  components: {
    Icon,
  },

  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style module>
@value (slowEaseFade) from '~css/transitions.css';

.collapseCaret {
  color: var(--jc-text-color-dark);
}

.collapsed {
  transform: rotate(-180deg);
  transition: slowEaseFade;
}

.notCollapsed {
  transform: rotate(0deg);
  transition: slowEaseFade;
}
</style>
